// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAU4oyCZVlRD74u52sLNNzyo7QtqS7yBdI",
  authDomain: "shop-fdbfd.firebaseapp.com",
  projectId: "shop-fdbfd",
  storageBucket: "shop-fdbfd.appspot.com",
  messagingSenderId: "866320740397",
  appId: "1:866320740397:web:344bc4069afb3f397788a4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;